import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import Title from "../title";
import Footer from "../footer";
import ImageRender from "./ImageRender";
import PageTitle from "../theme/components/pagetitle";
import {applyLang} from "../../../i18n";
import Loader from "../loader";
import logger from "../../../services/logger"

export default class GalerieImages extends Component{

    render(){
        const context=this.props.context
        const {org,config,data}=context

        logger.debug({ data }, "data")

        const galerie=applyLang(data[0],context.lang)

        const title=galerie.name
        const description=galerie.description
        const image=galerie.bgImage

        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} title={title} description={description} image={image}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <div>
                <Meta context={context} title={title} description={description} image={image}/>
                <div id="main" className="main-content-wraper">
                    <Header context={context}/>
                    <PageTitle context={context} title={title} description={description} broadcamp={[
                        {label:"Galeries Photo",url:org.BASE_WEB_URL+"/galeries"},
                    ]}/>
                    <div style={{marginTop: 20,minHeight:"50vh"}}>
                        <ImageRender context={context} galerie={galerie}/>
                    </div>
                    <Footer context={context}/>
                </div>
            </div>
        )
    }
}
